import {Button, message, Space} from "antd";
import {useState} from "react";
import {ProfileWidgetSkeleton} from "../../upcoming-calls/profile-widget/profile-widget-skeleton";
import {StyledShareServiceWidgetWrapper} from "./share-service-widget.style";
import {CopyIconSm, FacebookIconSm, MailIcon, XIcon} from "../../../icons/icons";
import {handleServiceBookingLink} from "../../../../utils/meeting";
import {useGetProfileContext} from "../../../../context/profile/profile-context";
import {GetSessionApiResponse} from "../../../../react-query-hooks/session/types/edit-session";

const ShareServiceWidget = ({
  serviceId,
  serviceData,
  isFetchingSession,
}: {
  serviceId: number;
  isFetchingSession?: boolean;
  serviceData: GetSessionApiResponse;
}) => {
  const [showMore, setShowMore] = useState(false);

  const {state: profileState} = useGetProfileContext();
  const stripedHtml = serviceData.description.replace(/<[^>]+>/g, "");
  return (
    <StyledShareServiceWidgetWrapper>
      {isFetchingSession ? (
        <ProfileWidgetSkeleton />
      ) : (
        <>
          <h2 className="profile-widget-heading">Share service link</h2>
          <div className="profile-widget-card">
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <div className="profile-widget-card-header">
                <h3 className="profile-widget-card-user-name">{serviceData.name}</h3>
                {/* <div>
                  <Button shape="circle" icon={<EditOutlined />} />
                </div> */}
              </div>
              <p className="profile-widget-card-bio">
                {showMore
                  ? stripedHtml
                  : stripedHtml && `${stripedHtml.substring(0, 100)}`}{" "}
                {stripedHtml && stripedHtml?.length > 100 && (
                  <Button
                    style={{paddingLeft: 0}}
                    size="small"
                    type="link"
                    onClick={() => setShowMore(!showMore)}
                  >
                    {showMore ? "Show less" : " ...Show more"}
                  </Button>
                )}
              </p>

              <div>
                <Button
                  size="small"
                  block
                  htmlType="button"
                  target="_blank"
                  href={handleServiceBookingLink({
                    serviceId: serviceId,
                    slug: serviceData.slug,
                    username: profileState.profileData.username,
                    windowNav: true,
                  })}
                >
                  View session page
                </Button>
              </div>
              <p className="profile-widget-card-bio">Share session via</p>
              <div>
                <Space direction="horizontal" size={12}>
                  <div
                    style={{
                      color: "#9254DE",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      href="#!"
                      title="Copy url"
                      onClick={() =>
                        navigator.clipboard
                          .writeText(
                            handleServiceBookingLink({
                              serviceId: serviceId,
                              slug: serviceData.slug,
                              username: profileState.profileData.username,
                              windowNav: true,
                            })
                          )
                          .then(() => message.success("Copied!"))
                      }
                    >
                      <CopyIconSm style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                  <div
                    style={{
                      color: "#3B5998",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://www.facebook.com/sharer/sharer.php?u=https%3A%2F%2Fcoachli.co%2F${profileState.profileData.username}&amp`}
                      title="Share on Facebook"
                    >
                      <FacebookIconSm style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                  <div
                    style={{
                      border: "none",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://twitter.com/intent/tweet?text=Book a session with me on Coachli!&url=${handleServiceBookingLink(
                        {
                          serviceId: serviceId,
                          slug: serviceData.slug,
                          username: profileState.profileData.username,
                          windowNav: true,
                        }
                      )}&hashtags=coachli,useCoachli`}
                      title="Share on X"
                    >
                      <XIcon style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                  <div
                    style={{
                      border: "none",
                      height: "3rem",
                      width: "3rem",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <a
                      href={`mailto:?subject=I wanted you to see this site&amp;body=Book a session with me on Coachli ${handleServiceBookingLink(
                        {
                          serviceId: serviceId,
                          slug: serviceData.slug,
                          username: profileState.profileData.username,
                          windowNav: true,
                        }
                      )}`}
                    >
                      <MailIcon style={{fontSize: "2rem"}} />
                    </a>
                  </div>
                </Space>
              </div>
            </Space>
          </div>
        </>
      )}
    </StyledShareServiceWidgetWrapper>
  );
};

export {ShareServiceWidget};
